import { gql } from '@apollo/client';

export const globalSearchGQL = gql`
  query globalSearch(
    $content: String!
    $linkedContractId: String
    $tenantCanCreateSubContract: Boolean
    $parkingIds: [String!]
    $isNotInPeriod: [String!]
  ) {
    globalSearch(
      content: $content
      linkedContractId: $linkedContractId
      tenantCanCreateSubContract: $tenantCanCreateSubContract
      parkingIds: $parkingIds
      isNotInPeriod: $isNotInPeriod
    ) {
      contracts {
        _id
        parkingId
        name1
        name2
        ospContractId
        isEnabled
        category
        contractCount
        presenceCounter
        spacesAllocated
        spacesOccupied
        productId
        startDate
        shortUid
        motoristId
        username
        address {
          address1
          address2
          zipcode
          city
          country
        }
        linkedContractId
        stopDate
        reference
        credentials {
          type
          provider
          value
          description
        }
        tenantContracts {
          _id
        }
      }
    }
  }
`;
